import { ScrollView } from "react-native";
import { Skeleton } from "../../Skeleton";

export const SuggestedActionsChipsSkeleton = ({
	height = 40,
}: {
	height?: number;
}) => {
	return (
		<ScrollView
			horizontal
			contentContainerStyle={{
				gap: 8,
				flex: 1,
			}}
		>
			<Skeleton width={150} height={height} borderRadius={8} />
			<Skeleton width={150} height={height} borderRadius={8} />
		</ScrollView>
	);
};
